import { useCallback, useEffect, useState } from "react";
import { useEntitlements } from "@/modules/useEntitlements";

const LS_KEY = "vf:sat_ui_diagnose_override";

/**
 * Modo diagnóstico SAT (banners técnicos visibles).
 * Fuente: GET /system/info → sat_hybrid.ui_diagnose_enabled (VF_SAT_UI_DIAGNOSE_ENABLED).
 * En desarrollo, localStorage puede forzar on/off para previsualizar la UI de producción.
 */
export function useSatUiDiagnose() {
  const { systemInfo, loading, reload } = useEntitlements();
  const serverEnabled = systemInfo?.sat_hybrid?.ui_diagnose_enabled === true;

  const [devOverride, setDevOverrideState] = useState(() => readDevOverride());

  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === LS_KEY) setDevOverrideState(readDevOverride());
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  const isDev = process.env.NODE_ENV === "development";
  const enabled = isDev && devOverride !== null ? devOverride : serverEnabled;

  const setDevOverride = useCallback((value) => {
    if (!isDev) return;
    try {
      if (value === null) {
        localStorage.removeItem(LS_KEY);
      } else {
        localStorage.setItem(LS_KEY, value ? "1" : "0");
      }
    } catch {
      /* ignore */
    }
    setDevOverrideState(value);
  }, [isDev]);

  return {
    enabled,
    serverEnabled,
    loading,
    isDev,
    devOverride,
    setDevOverride,
    reload,
  };
}

function readDevOverride() {
  if (process.env.NODE_ENV !== "development") return null;
  try {
    const raw = localStorage.getItem(LS_KEY);
    if (raw === "1" || raw === "true") return true;
    if (raw === "0" || raw === "false") return false;
  } catch {
    /* ignore */
  }
  return null;
}
